import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
export default {
  name: "view-all-reports",
  components: { pageheader },
  data() {
    return {
      input: {},
      reportArray: [],
    };
  },
  computed: {
    ...mapGetters(["roles", "smsCustomerId", "smsUserId", "permissions"]),
  },
  mounted() {
    this.input = utils.getInputContent("viewAllReports", this.roles);
    this.getReportsDynamic();
  },
  methods: {
    getReportsDynamic() {
      this.reportArray = this.permissions;
    },
    gotoUtilization() {
      this.$router.push({ name: "Utilization Report - Detailed" });
    },
    gotoExistingActiveAlerts() {
      this.$router.push({ name: "Existing Active Alerts" });
    },
    gotoOnRent() {
      this.$router.push({ name: "On Rent" });
    },
    gotoOnReservation() {
      this.$router.push({ name: "On Reservation" });
    },
    gotoOverdue() {
      this.$router.push({ name: "Overdue" });
    },
    gotoScheduledReport() {
      this.$router.push({ name: "Scheduled for Pickup" });
    },
    gotoNewOperational() {
      this.$router.push({ name: "New Operational" });
    },
    gotoTrip() {
      this.$router.push({ name: "Trip" });
    },
    gotoIncident() {
      this.$router.push({ name: "Incident" });
    },
    gotoActivity() {
      this.$router.push({ name: "Activity" });
    },
    gotoActualSpend() {
      this.$router.push({ name: "Actual Spend To Date" });
    },
    gotoOffRent() {
      this.$router.push({ name: "Off Rent" });
    },
    gotoOnRentWithCost() {
      this.$router.push({ name: "On Rent With Spend Analysis" });
    },
    gotoPlanned() {
      this.$router.push({ name: "Planned Vs Actual" });
    },
    gotoRentToDate() {
      this.$router.push({ name: "Rent To Date And Projected" });
    },
    gotoActiveMaintenance() {
      this.$router.push({ name: "Active Maintenance" });
    },
    gotoHistoricalMaintenance() {
      this.$router.push({ name: "Historical Maintenance" });
    },
    gotoCustomerBalance() {
      this.$router.push({ name: "Customer Balance" });
    },
    gotoServiceCall() {
      this.$router.push({ name: "Service Call" });
    },
    gotoItemsRented() {
      this.$router.push({ name: "Items Rented" });
    },
    gotoNewUtilization() {
      this.$router.push({ name: "Utilization" });
    },
  },
};
